import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Typography } from 'app/components/domain/typography';
import { config } from 'app/config/config';
import { AddressMapper } from 'app/page/orders/mapper/address-mapper';
import { i18n } from 'app/i18n';
import { RootState } from 'app/redux';
import {
    selectCustomerInformation,
    selectBillingAccount,
    selectServiceAddress,
} from 'app/page/orders/redux/order-selectors';

import styles from './footer.module.scss';

interface LinkType {
    label: string;
    url: string;
}

interface Props {
    fullName?: string;
    billingAccountId?: string;
    deliveryAddress?: string;
}

class FooterComponent extends Component<Props> {
    public readonly renderCustomerInfo = (): React.ReactNode => {
        const { fullName, billingAccountId, deliveryAddress } = this.props;

        return (
            billingAccountId && (
                <div className={styles.userInfo}>
                    {fullName && (
                        <Typography variant="body1" component="p" className={styles.text}>
                            {fullName}
                        </Typography>
                    )}
                    {deliveryAddress && (
                        <Typography variant="body1" component="p" className={styles.text}>
                            {deliveryAddress}
                        </Typography>
                    )}
                    <Typography variant="body1" component="p" className={styles.text}>
                        {`${i18n.components.footer.customerNumber}: ${billingAccountId}`}
                    </Typography>
                </div>
            )
        );
    };

    public readonly renderLinks = (): React.ReactNode => {
        const links: LinkType[] = [
            {
                url: config.CUSTOMER_SERVICE,
                label: i18n.components.footer.linkToCustomerService,
            },
            {
                url: config.HOME_PAGE_URL,
                label: i18n.components.footer.linkToMainPage,
            },
        ];

        return (
            <div className={styles.linksContainer}>
                {links.map((link, index) => (
                    <div key={index} className={styles.linkWrapper}>
                        <a href={link.url} className={styles.link}>
                            <Typography variant="body1" component="span">
                                {link.label}
                            </Typography>
                        </a>
                    </div>
                ))}
            </div>
        );
    };

    public render(): React.ReactNode {
        return (
            <footer className={styles.footer}>
                {this.renderCustomerInfo()}
                {this.renderLinks()}
            </footer>
        );
    }
}

const mapStateToProps = (state: RootState): Props => {
    const billingAccount = selectBillingAccount(state);
    const customerInformation = selectCustomerInformation(state);
    const deliveryServiceAddress = selectServiceAddress(state);

    return {
        fullName: customerInformation?.fullName,
        billingAccountId: billingAccount?.accountId,
        deliveryAddress: deliveryServiceAddress && AddressMapper.toDisplayStreet(deliveryServiceAddress),
    };
};

const Footer = connect(mapStateToProps)(FooterComponent);

export { Footer };
